// eslint-disable-next-line no-restricted-imports
import { Divider } from '@mui/material';

import { styled } from '../styled';
import { Colors } from '../theme';

export const DividerStyled = styled(Divider)(() => ({
  borderColor: Colors.gray200,
}));
